export interface FaqItem {
  q: string;
  a: string;
}

export const homeFaqs: FaqItem[] = [
  {
    q: '吃瓜观察局的内容是怎么整理的？',
    a: '我们会跟踪各平台的公开讨论，把同一话题下的关键节点按时间顺序整理成脉络，再把不同立场的观点归类呈现。所有内容都基于公开可见的讨论，不添加未经证实的信息。',
  },
  {
    q: '热度值是怎么计算的？',
    a: '热度值综合了话题的阅读量、评论量、转发量与讨论增速四项指标，并做归一化处理后得出。它反映的是话题当下的关注度，并不代表内容的真实程度。',
  },
  {
    q: '观点分布里的正反方代表什么？',
    a: '正反方是根据网友公开表达的立场抽样统计得出的相对比例，仅用于呈现讨论的大致倾向。它不代表平台立场，也不代表事实结论。',
  },
  {
    q: '评论区的留言都是真实的吗？',
    a: '评论区展示的是经过整理的公开讨论留言。我们会对明显的攻击性、涉及隐私的内容做处理，保留讨论中具有代表性的观点表达。',
  },
  {
    q: '如果话题后续有了新进展，会更新吗？',
    a: '会。每个话题都有一个持续更新的时间脉络，新的公开进展会被补充进去，已发布的内容如果被证实有误，我们会在原位置标注更正说明。',
  },
  {
    q: '如何向你们反馈内容问题？',
    a: '可以通过页脚或关于我们页面留下的邮箱联系我们。涉及事实更正、隐私问题的反馈我们会优先处理，并在核实后尽快调整。',
  },
];